import mapActions from './mapActions';

export default mapActions('my_groups', {
    fetchAll_url: data => `/api/employees/${data.id}/my_groups`
});
